import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import AddSalesRegister from './AddSalesRegister';
import LoanSummaryModal from '../../shared/finance/LoanSummaryModal'
import EditSalesRegister from './EditSalesRegister';
import ViewSalesRegister from './ViewSalesRegister';
import DeleteSalesRegister from './DeleteSalesRegister';
import SalesRegisterModel from './models/SalesRegisterModel';
import { logAuditEvent } from '../../utils/auditLogger';

function SalesRegisterModal({onClose, onSubmit, UserAction, show, selectedRow, moduleName}) {
    const [childData, setChildData] = useState(new SalesRegisterModel());
    const [loanSummary, setLoanSummary] = useState(null);
    const [showLoanSummary, setShowLoanSummary] = useState(false);
    const loanSummaryApplyRef = useRef(null);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
        if (show && selectedRow) {
          setChildData({ ...selectedRow });
        } else if (!show) {
          setChildData(new SalesRegisterModel());
        }
    }, [selectedRow, show]);

    const handleDataFromChild = useCallback((data) => {
        if (typeof data === 'function') {
            setChildData((prev) => data(prev));
        } else {
            setChildData(data);
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);
    };

    const handleLoad = useCallback((data) => {
        setChildData(data);
    }, []);

    const handleLoanSummaryRequest = useCallback((summary) => {
        setLoanSummary(summary);
        setShowLoanSummary(true);
    }, []);

    const closeLoanSummaryModal = useCallback(() => {
        setShowLoanSummary(false);
        if (loanSummary && typeof loanSummaryApplyRef.current === 'function') {
            loanSummaryApplyRef.current(loanSummary);
        }
    }, [loanSummary]);

    const handleCancel = (label) => {
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`)
        onClose()
    }
    if(UserAction === "Add"){
        modalAction = (
            <AddSalesRegister
                onLoad={handleLoad}
                sendDataToParent={handleDataFromChild}
                onLoanSummary={handleLoanSummaryRequest}
                onRegisterLoanSummaryApply={(fn) => { loanSummaryApplyRef.current = fn; }}
            />
        );
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = (
            <EditSalesRegister
                selectedRow={selectedRow}
                sendDataToParent={handleDataFromChild}
                onLoanSummary={handleLoanSummaryRequest}
                onRegisterLoanSummaryApply={(fn) => { loanSummaryApplyRef.current = fn; }}
            />
        );
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewSalesRegister SalesRegisterData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Cancel</button>
                    </div>
    } else if(UserAction === "Delete"){
        modalAction = <DeleteSalesRegister selectedRow={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={onClose}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
                    </div>
    }
  return (
    <>
        {UserAction !== "Delete" ? (
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                dialogClassName="add-centered-sales-modal" 
                style={{ maxWidth: "1319px !important" }}
            >
                <ModalHeader className="modal-header border-0 custom-modal-header">
                    <ModalTitle >{userAction +" "+ moduleName} </ModalTitle>
                    <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal>
        ) : (
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
            >
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0" />
                        </div>
                        <div> {userAction} {moduleName}</div>
                    </ModalTitle>
                    <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
                </ModalHeader>
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>
        )}
        <LoanSummaryModal show={showLoanSummary} onClose={closeLoanSummaryModal} summary={loanSummary} />
    </>
  )
}

export default SalesRegisterModal